"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Select = void 0;
const classnames_1 = __importDefault(require("classnames"));
const react_1 = __importStar(require("react"));
const Icon_1 = require("../Icon");
const Text_1 = require("../Text");
function Select({ onSelect, id, options, placeholder, className, testId, }) {
    const [open, setOpen] = (0, react_1.useState)(false);
    const [selected, setSelected] = (0, react_1.useState)(null);
    (0, react_1.useEffect)(() => {
        function handleOutsideClick(event) {
            if (open && event.target.id !== id)
                setOpen(false);
        }
        document.addEventListener('click', handleOutsideClick);
        return () => document.removeEventListener('click', handleOutsideClick);
    }, [open, id]);
    return (react_1.default.createElement("div", { id: id, className: className, "data-testid": testId, onBlur: () => setOpen(false) },
        placeholder && (react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.UI_ELEMENT, className: (0, classnames_1.default)('text-[12px] text-disabledTextColor pl-4 pb-1', {
                'opacity-0': !selected,
            }) }, placeholder)),
        react_1.default.createElement("div", { className: "select-none relative", onClick: (e) => {
                e.preventDefault();
                setOpen(!open);
            } },
            react_1.default.createElement("div", { className: "bg-transparent border border-borderColor rounded outline-none focus:ring-transparent focus:border-transparent hover:cursor-pointer flex justify-between" },
                react_1.default.createElement("div", { className: "relative bg-transparent border-none outline-none focus:ring focus:border-transparent hover:border-transparent border-transparent shadow-none hover:cursor-pointer" },
                    react_1.default.createElement("div", { className: "p-3 pl-4 bg-transparent outline-none focus:ring focus:border-transparent hover:cursor-pointer" },
                        !selected && placeholder && (react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.UI_ELEMENT, disabled: true }, placeholder)),
                        selected && (react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.UI_ELEMENT, subdued: true }, selected.label)))),
                react_1.default.createElement("div", { className: "p-3" },
                    react_1.default.createElement(Icon_1.Icon.ChevronDown, null))),
            open && (react_1.default.createElement("div", { className: 'absolute top-[100%] bg-defaultBg rounded w-full shadow-2xl' },
                react_1.default.createElement("ul", { className: "bg-defaultBg z-10 relative" }, options.map((option) => (react_1.default.createElement("li", { key: option.label, onClick: (e) => {
                        e.preventDefault();
                        setSelected(option);
                        onSelect(option);
                    }, className: "pl-4 py-2 hover:bg-surface-subdued hover:cursor-pointer", "data-testid": `select:${option.label}` },
                    react_1.default.createElement(Text_1.Text, { type: Text_1.TextType.UI_ELEMENT, className: "cursor-pointer" }, option.label))))))))));
}
exports.Select = Select;
//# sourceMappingURL=Select.js.map